import { ITransshipment, TTransshipmentStepId } from '../../types';

const selfie = {
  path: 'documentos/selfie',
  next: (trans: ITransshipment): TTransshipmentStepId =>
    trans.type === 'representative' ? 'documents-success-page' : 'success-page',
};

export default selfie;
